module.exports = __webpack_public_path__ + "img/img1.fad85013.jpg";